import React from "react";

class ErrorModal extends React.Component {

    render(){
        return(
            <div className="modal fade" id="errorModal" tabIndex="-1" role="dialog" aria-labelledby="errorModal" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLongTitle">Something Went Wrong! </h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            Are you sure you want to delete User ID <b>#{this.props.id}</b>?
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-success" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ErrorModal


// WEBPACK FOOTER //
// ./src/views/etc/modals/Error.js